import { Dictionary } from '@ngrx/entity';
import * as _ from 'lodash';



export const clearMatrixArr = (arrList: unknown[][]): unknown[] => {
  return _.map(arrList, (arr) => clearOneArr(arr));
}

export const clearOneArr = (arr: unknown[]): unknown[] => {
  return _.pullAll(arr, arr);
}

export const toDictionary = <T extends { id: string }>(list: T[]): Dictionary<T> => {
  return Object.assign({}, ...list.map((data: T) => ({[data.id]: data})));
}

export const extractIdsArray = <T extends { id: string }>(list: T[]): string[] => {
  return list.map((data: T) => data.id);
}
